export const TERMINAL_TYPES = {
  HPBX_PHONE: 'HPBXPhone',
  INTERNAL_PHONE: 'InternalPhone',
  PRIVATE_PHONE: 'PrivatePhone',
  CUSTOM: 'Custom'
};
